import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import ReactTooltip from 'react-tooltip';
import CartTimer from './CartTimer/CartTimer';
import EventPriceOptionsModal from '../Common/EventPriceOptionsModal/EventPriceOptionsModal';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import moment from 'moment';
import './Cart.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Cart extends Component {
	constructor(props) {
        super(props);
        this.state = {
            isEventPriceOptionsOpen: false,
            pricingOptions: [],
            currentPrice: {}
        }
    }

    triggerPriceChangeFlow = async (ticket) => {
        const {
            event_date_id,
            section_id,
            pricing_option_id
        } = ticket;
        const query = this.props.user.role ? `/box-office/pricing-options` : `/tickets/pricing-options`;

        try {
            const response = await ApiRequest(`${query}?event_date_id=${event_date_id}&section_id=${section_id}`);
            console.log('Get Pricing Options Response: ', response);
            this.setState({ 
                pricingOptions: response.data.pricing_options,
                currentPrice: response.data.pricing_options.find(price => price.id === pricing_option_id),
                ticket
            });
        } catch (error) {
            console.log(error);
        }

        this.toggleEventPriceOption();
    }
    
    handlePriceChange = (e) => {
        let id = e.target.value;
        let currentPrice = { ...this.state.currentPrice };
        this.state.pricingOptions.forEach((price) => {
            if (price.id === parseInt(id, 0)) {
                currentPrice = price;
            }
        });
        
        this.setState(
            {
                currentPrice
            },
            () => {
                this.confirmEventPriceOption();
            }
        );
    }

    addPropsToCurrentPrice = (currentPrice) => {
        const {
            event_date_id,
            section_id,
            row_id,
            seat_id
        } = this.state.ticket;

        const newCurrentPrice = { ...currentPrice };

        newCurrentPrice.pricing_option_id = newCurrentPrice.id;
        newCurrentPrice.event_date_id = event_date_id;
        newCurrentPrice.section_id = section_id;
        newCurrentPrice.row_id = row_id;
        newCurrentPrice.seat_id = seat_id;

        return newCurrentPrice;
    }

    confirmEventPriceOption = async () => {
        this.props.updateTicketsInCart(this.addPropsToCurrentPrice(this.state.currentPrice), 'reserved', this.state.ticket.id);

        this.setState({ isEventPriceOptionsOpen: false });
    }

    toggleEventPriceOption = () => {
        this.setState({
            isEventPriceOptionsOpen: !this.state.isEventPriceOptionsOpen
        });
    }

	editTicket = (key, parentKey) => {
		this.props.onEditTicket(key, parentKey);
    }

    renderST4UFees = () => {
        if (this.props.billing.method === 'cash' || this.props.billing.method === 'check') {
            return null;
        } else {
            if (this.props.cartPricing.st4u_fees > 0 && this.props.billing.method !== 'reserved' && this.props.billing.method !== 'vipatron') {
                return (
                    <div className="showtix-cart-calc-item">
                        {strings.showtixFees}
                        <span className="showtix-cart-calc-item__total">
                            {
                                new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD'
                                }).format(this.props.cartPricing.st4u_fees)
                            }
                        </span>
                    </div>
                );
            }
        }
    }

	render() {
        let feesString = '';
        if (this.props.cartPricing) {
            if(this.props.cartPricing.client_fees_detail) {
                if(this.props.cartPricing.client_fees_detail.length > 0) {
                    this.props.cartPricing.client_fees_detail.forEach((fee) => {
                        feesString += `${fee.desc} : ${new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD'
                        }).format(fee.amount)} <br />`;
                    });
                }
            }
        }
	  	return (
            <React.Fragment>
                <EventPriceOptionsModal
                    isEventPriceOptionsOpen={this.state.isEventPriceOptionsOpen}
                    toggleEventPriceOption={this.toggleEventPriceOption}
                    confirmEventPriceOption={this.confirmEventPriceOption}
                    pricingOptions={this.state.pricingOptions}
                    currentPrice={this.state.currentPrice}
                    handlePriceChange={this.handlePriceChange}
                    user={this.props.user}
                />
                <div
                    className={this.props.isCartOpen ? 'showtix-cart  is-active' : 'showtix-cart'}
                    id="cart-main"
                >
                    <CartTimer
                        timer={this.props.timer}
                        toggleTimerUp={this.props.toggleTimerUp} />
                    {(this.props.cartItems.length > 0 || this.props.cartPricing.donation > 0) &&
                        <div className="showtix-cart__body">
                            <h2 className="showtix-cart__title">{strings.cart}</h2>
                            {
                                this.props.cartItems.map((cartItem, i) => {
                                    let eventName = '';
                                    let hasOnlySocialTickets = false;
                                    let socialDistanceTickets = 0;
                                    if (cartItem.length > 0) {
                                        cartItem.forEach((ticket) => {
                                            if (ticket.social_distance) {
                                                socialDistanceTickets++;
                                            } else {
                                                eventName = ticket.name;
                                            }
                                        });
                                        hasOnlySocialTickets = socialDistanceTickets === cartItem.length;
                                    }
                                    console.log('hasOnlySocialTickets', hasOnlySocialTickets)
                                    const showDateLabel = cartItem[0].type !== 'flexpass' && cartItem[0].event_type === 'Event';
                                    if (!hasOnlySocialTickets) {
                                        return (
                                            <div key={i} className="showtix-cart-item">
                                                <div className="showtix-cart-item__header d-flex">
                                                    <div className="showtix-cart-item__poster">
                                                        {cartItem[0].poster_graphic_url ?
                                                            <img src={cartItem[0].poster_graphic_url} alt={eventName} />
                                                            :
                                                            (cartItem[0].type === "flexpass" ?
                                                                <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_flex.jpg"} key={0} alt={cartItem[0].name} />
                                                                :
                                                                <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_event.jpg"} key={1} alt={cartItem[0].name} />
                                                            )
                                                        }
                                                    </div>
                                                    <div className="showtix-cart-item__infos">
                                                        <h3 className="showtix-cart-item__title">{eventName}</h3>
                                                        {showDateLabel &&
                                                            <p className="showtix-cart-item__date">
                                                                {moment(cartItem[0].event_datetime_local.substring(0, 19)).format('LLLL')}
                                                            </p>
                                                        }
                                                    </div>
                                                </div>
                                                <ul className="showtix-cart-item__body" aria-label={`List of tickets for ${eventName}`}>
                                                    {
                                                        cartItem.map((ticket, j) => {
                                                            let full_seat_name = ticket.full_seat_name === '' ? ticket.desc : ticket.full_seat_name;
                                                            if (!ticket.social_distance) {
                                                                //full_seat_name = 'Social Distance seat';
                                                                return (
                                                                    <li key={j} className="showtix-cart-item-ticket">
                                                                        <span className="showtix-badge showtix-background__grey-3" aria-hidden="true">
                                                                            {(() => {
                                                                                switch (ticket.type) {
                                                                                    case 'general-admission': return strings.generalAdmission;
                                                                                    case 'reserved': return strings.reservedSeating;
                                                                                    case 'flexpass': return strings.flexpass;
                                                                                    default: return strings.generalAdmission;
                                                                                }
                                                                            })()}
                                                                        </span>
                                                                        <span
                                                                            className="showtix-cart-item-ticket__name"
                                                                            onClick={() => this.triggerPriceChangeFlow(ticket)}
                                                                            >
                                                                            {ticket.social_distance ? (
                                                                                full_seat_name
                                                                            ) : (
                                                                                <React.Fragment>        
                                                                                    {ticket.type === 'reserved' ? full_seat_name : ticket.desc} - {new Intl.NumberFormat('en-US', {
                                                                                        style: 'currency',
                                                                                        currency: 'USD'
                                                                                    }).format(ticket.amount)} 
                                                                                </React.Fragment>  
                                                                            )}
                                                                        </span>
                                                                        {ticket.social_distance ? (
                                                                            <React.Fragment>
    
                                                                            </React.Fragment>
                                                                        ) : (
                                                                            <button
                                                                                className="showtix-cart-item-ticket__edit"
                                                                                onClick={() => this.props.deleteFromCart(ticket)}
                                                                                aria-label={`Remove ticket ${ticket.type === 'reserved' ? full_seat_name : ticket.desc} from Cart`}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        )}
                                                                    </li>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        )
                                    } else {
                                        return null;
                                    }
                                })
                            }

                            {this.props.cartPricing.donation > 0 &&
                                <div className="showtix-cart-item">
                                    <div className="showtix-cart-item__body">
                                        <div className="showtix-cart-item-ticket">
                                            DONATION
                                            -&nbsp;
                                    {new Intl.NumberFormat('en-US', {
                                                style: 'currency',
                                                currency: 'USD'
                                            }).format(this.props.cartPricing.donation)}
                                            <button
                                                className="showtix-cart-item-ticket__edit"
                                                onClick={() => this.props.clearDonationFromCart()}
                                                aria-label="Remove donation"
                                            >X</button>
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className="showtix-cart-calc">
                                <div className="showtix-cart-calc-item">
                                    {this.props.totalItemsInCart} {this.props.totalItemsInCart === 1 ? strings.totalItem : strings.totalItems}
                                </div>

                                {this.props.cartPricing.gross_coupon_discount > 0 &&
                                    <div className="showtix-cart-calc-item is-promo">
                                        DISCOUNT
                                <span className="showtix-cart-calc-item__total">
                                            -{
                                                new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD'
                                                }).format(this.props.cartPricing.gross_coupon_discount)
                                            }
                                        </span>
                                    </div>
                                }

                                {this.renderST4UFees()}

                                {this.props.cartPricing.client_fees > 0 &&
                                    this.props.billing.method !== 'reserved' && this.props.billing.method !== 'vipatron' &&
                                    <div className="showtix-cart-calc-item">
                                        {strings.miscFees}
                                        <span href="#" id="tooltip-fees" className="showtix-tooltip" data-tip={feesString} data-html={true}>!</span>
                                        <ReactTooltip html={true} />

                                        <span className="showtix-cart-calc-item__total">
                                            {
                                                new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD'
                                                }).format(this.props.cartPricing.client_fees)
                                            }
                                        </span>
                                    </div>
                                }
                            </div>

                            <div className="showtix-cart-total">
                                <div className="showtix-cart-total-item">
                                    {strings.total}
                                    {!isNaN(this.props.cartPricing.txn_gross) &&
                                        <span className="showtix-cart-total-item__total">
                                            {this.props.billing.method !== 'reserved' && this.props.billing.method !== 'vipatron' ?
                                                new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD'
                                                }).format(this.props.cartPricing.txn_gross)
                                                :
                                                new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD'
                                                }).format(this.props.cartItems.reduce((grandTotal, cartItem) => grandTotal + cartItem.reduce((total, ticket) => total + ticket.amount, 0), 0))
                                            }
                                        </span>
                                    }
                                </div>
                                {
                                    !this.props.isBillingOpen &&
                                    <div className="d-flex justify-content-end">
                                        <button
                                            className="showtix-button showtix-button__small showtix-background__primary-3"
                                            onClick={() => {
                                                for (let key in this.props.isCategoryOpen) {
                                                    this.props.isCategoryOpen[key] === true && this.props.toggleCategory(key)
                                                }
                                                this.props.toggleBilling(true);
                                                this.props.isTicketsOpen && this.props.toggleTickets();
                                            }}
                                        ><span>{strings.checkout}</span></button>
                                    </div>
                                }
                                {this.props.terminal && (
                                    <div className="d-flex justify-content-end showtix-cart__buttons">
                                        {(this.props.billing.method === 'reader' && this.props.isCustomerInfoOpen) && (
                                            <button
                                                className="showtix-button showtix-button__small showtix-background__primary-3"
                                                onClick={() => this.props.clearReaderDisplay()}
                                            ><span>Reset</span></button>
                                        )}
                                        <button
                                            className="showtix-button showtix-button__small showtix-background__primary-4"
                                            onClick={() => this.props.cancelCart()}
                                        ><span>Cancel</span></button>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                </div>
            </React.Fragment>
	  	);
	}
}

Cart.propTypes = {
    onEditTicket: PropTypes.func,
    updateTicketsInCart: PropTypes.func,
    checkout: PropTypes.func,
    isCartOpen: PropTypes.bool,
    cartItems: PropTypes.array
}

export default Cart;



// WEBPACK FOOTER //
// ./src/components/Cart/Cart.js